"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeForm = void 0;
var dayjs_1 = __importDefault(require("./dayjs"));
var utils_1 = require("./utils");
var defaultSettings = {
    widgets: [
        {
            order: 0,
            id: 'aspects-table',
            isActive: false
        },
        {
            order: 2,
            id: 'strong-objects',
            isActive: false
        },
        {
            order: 3,
            id: 'house-formulas',
            isActive: false
        },
        {
            order: 4,
            id: 'analyze',
            isActive: false
        },
        {
            order: 6,
            id: 'orbise-corrector',
            isActive: false
        },
        {
            order: 7,
            id: 'rectification',
            isActive: false
        },
        {
            order: 8,
            id: 'devplan',
            isActive: false
        },
        {
            order: 9,
            id: 'autoprediction',
            isActive: false
        },
        {
            order: 10,
            id: 'interpretation',
            isActive: false
        },
    ],
    modes: {
        prognostics: [
            'directions',
            'solars',
            'transits',
            'prog_natal'
        ],
        synastry: [
            'syn_natal',
            'compatibility1',
            'partner1',
        ],
        relocation: ['relocation_natal']
    },
    dfltModes: [],
    dfltPrognostics: [],
    dfltSynastry: [],
    dfltRelocation: []
};
var defaultNatalData = {
    dt: new Date().toISOString(),
    gmt: (0, dayjs_1.default)().utcOffset() / 60,
    autoGmt: true,
    place: {},
};
var defaultPartnerData = __assign(__assign({}, defaultNatalData), { gender: 'female' });
function makeForm(data, astroSettings) {
    var _a;
    return __assign({ id: -1, userId: -1, name: "chronos.app.newMap", cosmogram: false, color: '#5E5E5E', isPinned: false, access: {
            type: 'private',
            showPersonalData: true,
        }, labels: [], modified: (0, dayjs_1.default)().toISOString(), folderId: null, useNatalPlace: (_a = astroSettings === null || astroSettings === void 0 ? void 0 : astroSettings.useNatalPlace) !== null && _a !== void 0 ? _a : false, housesSystem: utils_1.defaultHousesSystem, gen: {
            autoprediction: false,
            devplan: false,
            rectification: false
        }, settings: defaultSettings, natal: defaultPartnerData, synastry: defaultPartnerData, syn_prognostics: null, partners: [defaultPartnerData], prognostics: defaultNatalData, horar: __assign(__assign({}, defaultNatalData), { question: '???', housesSystem: 0 }), rectification: {
            interval: 600,
            step: 60,
            events: []
        } }, data);
}
exports.makeForm = makeForm;
